import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';

export default class Scanner {
  constructor() {
    this.camera = { facingMode: 'environment' };
    this.config = { fps: 10, qrbox: { width: 250, height: 250 } };
    this.scanner = new Html5Qrcode('reader', { formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE] });
    this.wrapper = document.querySelector('[data-wrapper]');
  }

  static init() {
    return new Scanner();
  }

  start(onRead) {
    this.scanner.start(this.camera, this.config, (value) => this.success(value, onRead));
  }

  onStop() {
  }

  onStopError(error) {
    $.notify({ title: error });
  }

  stop() {
    this.scanner.stop().then(this.onStop.bind(this)).catch(this.onStopError.bind(this));
  }

  success(value, callback) {
    this.stop(callback);

    callback(value);
  }
}
